import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
const variantClasses = {
    primary: 'bg-primary text-on-primary hover:bg-primary-hover active:bg-primary-active',
    accent: 'bg-accent text-white hover:bg-[#e64400] active:bg-[#cc3d00]',
    secondary: 'bg-surface-container-low text-on-surface border border-outline-variant hover:bg-surface-container active:bg-surface-container',
    ghost: 'bg-transparent text-primary hover:bg-primary-container active:bg-primary-container',
    destructive: 'bg-error text-white hover:bg-[#a01717] active:bg-[#8c1414]',
};
export function Button({ variant = 'primary', loading = false, icon, children, disabled, className = '', ...props }) {
    const isDisabled = disabled || loading;
    return (_jsxs("button", { ...props, disabled: isDisabled, className: [
            'inline-flex items-center justify-center gap-2 h-11 px-4 rounded-[12px]',
            'text-[16px] font-semibold leading-none',
            'transition-colors duration-150',
            'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
            variantClasses[variant],
            isDisabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer',
            className,
        ].join(' '), children: [loading ? (_jsx("span", { className: "w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin shrink-0" })) : icon ? (_jsx("span", { className: "shrink-0", children: icon })) : null, children] }));
}
